<script setup lang="ts">
import type { BrandsResponse } from '@laam/cms-shared';
import BrandLogoCard from '~/components/brands/BrandLogoCard.vue';
interface BrandsSubListProps {
	brandInitial?: string;
	activePill?: number;
}
const props = defineProps<BrandsSubListProps>();
const groupedList = inject('groupedList') as (
	brandInitial: string,
) => BrandsResponse;
const handleClick = inject('handleClick') as (
	brandName: string,
	brandHandle: string,
	image: string,
	verticalIndex: number,
	productCount: number,
) => void;
const brands = inject('brands') as Ref<BrandsResponse>;
const brandsData = computed(() => {
	if (!props.brandInitial) {
		return brands.value;
	}
	return groupedList(props.brandInitial);
});
</script>
<template>
	<div v-for="(brand, index2) in brandsData" :key="index2" class="flex py-md">
		<NuxtLink
			class="flex items-center gap-xl hover:cursor-pointer"
			:to="`/brands/${brand.handle}${activePill ? `?node_id=${activePill}` : ''}`"
			@click="
				handleClick(
					brand.name,
					brand.handle,
					brand.logo,
					index2,
					brand.product_count,
				)
			"
		>
			<BrandLogoCard
				:entity-data="{
					id: brand.id,
					href: `/brands/${brand.handle}`,
					logo: brand.logo,
					name: brand.name,
					entity: 'brand',
				}"
				variant="list"
			/>
			<div class="flex flex-col gap-xxs">
				<p class="truncate text-gray-700 text-md font-medium">
					{{ brand.name }}
				</p>
				<p class="text-gray-500 text-xs">{{ brand.product_count }} items</p>
			</div>
		</NuxtLink>
	</div>
</template>
